import { Trans } from "@lingui/react/macro";
import React from "react";
import { PrePostItem } from "./types";
import { isPresent } from "src/utils/checks";
import { DayByDay } from "src/page-components/cruise/itinerary/day-by-day";
import { InclusionContent } from "@silversea-ssc/ui-components-react";

export const formatArrivalDepartureTime = (
  arrivalTime?: string,
  departureTime?: string
): JSX.Element | string => {
  if (!arrivalTime && !departureTime) return "";
  if (arrivalTime && departureTime) return `${arrivalTime} - ${departureTime}`;

  if (arrivalTime)
    return (
      <React.Fragment>
        <Trans>Arrival</Trans> {arrivalTime}
      </React.Fragment>
    );
  if (departureTime)
    return (
      <React.Fragment>
        <Trans>Departure</Trans> {departureTime}
      </React.Fragment>
    );

  return "";
};

export const buildPrePost = (
  prePosts: readonly DayByDay[],
  inclusionsContent: readonly InclusionContent[]
): readonly PrePostItem[] =>
  prePosts
    .map((prePost) => {
      const content = inclusionsContent.find((x) =>
        x.codes.some((inclusionCode) => inclusionCode === prePost.inclusionCode)
      );
      return content ? { ...prePost, content } : undefined;
    })
    .filter(isPresent);
